import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=0534fac4&scoped=true&"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=0534fac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534fac4",
  null
  
)

export default component.exports